import { render, staticRenderFns } from "./ScoreIndicator.vue?vue&type=template&id=27b90c52&scoped=true"
import script from "./ScoreIndicator.vue?vue&type=script&lang=js"
export * from "./ScoreIndicator.vue?vue&type=script&lang=js"
import style0 from "./ScoreIndicator.vue?vue&type=style&index=0&id=27b90c52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b90c52",
  null
  
)

export default component.exports